<template v-slot=button-content>
  <span class="fa-stack" v-bind:class="{ 'font-size': computedFontSize }" v-on:click="xButtonClicked()">
    <i class="fa fa-circle fa-stack-2x"></i>
    <i class="fas fa-times fa-stack-1x"></i>
  </span>
</template>

<script>
export default {
  computed: {
    computedFontSize () {
      return this.fontSize ? this.fontSize + 'rem' : '0.7rem'
    }
  },
  methods: {
    xButtonClicked () {
      this.$emit('x-button-clicked')
    }
  },
  props: ['fontSize']
}
</script>

<style scoped>
.fa-circle {
  color: white;
}

.fa-stack {
  float: right;
  font-size: 0.7rem;
}
</style>



// WEBPACK FOOTER //
// src/components/general/buttons/CircleEnclosedXButton.vue